<template>
  <div class="m-5">
    <d-table class="mt-10" :data="mentees" :loading="loadingMentees" paginated backend-pagination :total="total" backend-search backend-sorting :default-sort="[pagination.sortField, pagination.sortOrder]" striped default-sort-direction="desc" show-search :per-page="pagination.pageSize" :search.sync="filter" @page-change="page => pagination.page = page" @sort="onSort">
      <template #action-buttons>
        <h2 class=" text-primary-500 mb-0">
          My Mentees
        </h2>
      </template>

      <template slot-scope="props">
        <d-table-column field="firstName" :row="props.row" label="Name" sortable>
          {{ props.row.fullName }}
        </d-table-column>
        <d-table-column field="email" :row="props.row" label="School Email" sortable>
          {{ props.row.schoolEmail }}
        </d-table-column>
        <d-table-column field="email" :row="props.row" label="Personal Email" sortable>
          {{ props.row.personalEmail }}
        </d-table-column>
        <d-table-column field="contactPreference" :row="props.row" label="Contact Preference" sortable>
          {{ props.row.contactPreference }}
        </d-table-column>
        <d-table-column field="lastLoginDate" label="Last Login" sortable>
          <span v-if="props.row.lastLoginDate">
            {{ props.row.lastLoginDate | formatShortDate }}
          </span>
          <span v-else>
            Never
          </span>
        </d-table-column>
        <d-table-column field="profile" :row="props.row" label="Profile">
          <a target="_blank" :href="'/profile/'+props.row.id">Profile</a>
        </d-table-column>
        <d-table-column class="" label="Contact">
          <d-icon icon="envelope" class="cursor-pointer ml-4" @click.native="launchNotificationsModal(props.row)" />
        </d-table-column>
      </template>
    </d-table>
  </div>
</template>

<script>
  import axios from 'axios';
  import ViewNotificationModal from '@resources/scripts/patterns/ViewNotificationModal.vue';

  export default {
    parent: true,

    data: () => ({
      mentees: [],

      loadingMentees: false,
      total: 0,
      filter: '',
      pagination: {
        page: 1,
        pageSize: 50,
        sortField: 'firstName',
        sortOrder: 'asc',
      },
    }),

    watch: {
      pagination: {
        handler() {
          this.getMenteesPaged();
        },
        deep: true,
      },
      filter() {
        this.getMenteesPaged();
      },
    },

    mounted() {
      this.getMenteesPaged();
    },

    methods: {
      async getMenteesPaged() {
        const {
          page, sortField, sortOrder, pageSize,
        } = this.pagination;
        const params = [`filter=${this.filter}`, `sortDir=${sortField} ${sortOrder}`, `currentPage=${page}`, `pageSize=${pageSize}`].join('&');
        this.loadingMentees = true;
        const { data } = await axios.get(`/api/mentor/mentees/paged?${params}`);
        this.mentees = data.resultItems;
        this.total = data.totalRecords;
        this.loadingMentees = false;
      },

      launchNotificationsModal(user) {
        this.$modal.open({
          parent: this,
          component: ViewNotificationModal,
          hasModalCard: true,
          props: {
            entityId: user.id,
            type: 'user',
            name: user.fullName,
          },
        });
      },

      onSort(field, order) {
        this.pagination.sortField = field;
        this.pagination.sortOrder = order;
      },

    },

  };
</script>
